import { render, staticRenderFns } from "./ReviewStatus.vue?vue&type=template&id=9af5a33e&scoped=true&"
import script from "./ReviewStatus.vue?vue&type=script&lang=js&"
export * from "./ReviewStatus.vue?vue&type=script&lang=js&"
import style0 from "./ReviewStatus.vue?vue&type=style&index=0&id=9af5a33e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af5a33e",
  null
  
)

export default component.exports